import { useEffect, useRef } from "react";
import { Bold, Italic, Underline, List, ListOrdered, Eraser } from "lucide-react";

export const RichTextEditor = ({ value, resetKey, onChange, testId }) => {
    const ref = useRef(null);

    useEffect(() => {
        if (ref.current) ref.current.innerHTML = value || "";
        // sincroniza o conteúdo apenas quando o alvo muda (nova peça / edição),
        // nunca durante a digitação — para não perder o cursor
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetKey]);

    const emit = () => onChange(ref.current?.innerHTML || "");

    const exec = (cmd) => {
        ref.current?.focus();
        document.execCommand(cmd, false, null);
        emit();
    };

    const tools = [
        { icon: Bold, cmd: "bold", label: "Negrito", tid: "editor-bold" },
        { icon: Italic, cmd: "italic", label: "Itálico", tid: "editor-italic" },
        { icon: Underline, cmd: "underline", label: "Sublinhado", tid: "editor-underline" },
        { icon: List, cmd: "insertUnorderedList", label: "Lista com marcadores", tid: "editor-ul" },
        { icon: ListOrdered, cmd: "insertOrderedList", label: "Lista numerada", tid: "editor-ol" },
        { icon: Eraser, cmd: "removeFormat", label: "Limpar formatação", tid: "editor-clear" },
    ];

    return (
        <div className="space-y-2">
            <div className="flex flex-wrap gap-1">
                {tools.map(({ icon: Icon, cmd, label, tid }) => (
                    <button
                        key={cmd}
                        type="button"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => exec(cmd)}
                        aria-label={label}
                        title={label}
                        data-testid={tid}
                        className="flex h-8 w-8 items-center justify-center border border-forge-line bg-forge-ink text-forge-paper transition-colors duration-300 hover:border-forge-yellow/60 hover:text-forge-yellow"
                    >
                        <Icon className="h-3.5 w-3.5" />
                    </button>
                ))}
            </div>
            <div
                ref={ref}
                contentEditable
                suppressContentEditableWarning
                onInput={emit}
                onBlur={emit}
                data-testid={testId}
                data-lenis-prevent="true"
                role="textbox"
                aria-multiline="true"
                className="max-h-56 min-h-[110px] overflow-y-auto border border-forge-line bg-forge-ink px-3 py-2 text-sm leading-relaxed text-forge-paper transition-colors duration-300 focus:border-forge-yellow/60 focus:outline-none [&_b]:text-forge-yellow [&_strong]:text-forge-yellow"
            />
        </div>
    );
};

export default RichTextEditor;
